import SaudeDaMulherIcon from '@/components/icons/IndicadoresAps/eSFeAP/SaudeDaMulher.vue'

export default {
  value: 'c7',
  label: 'Saúde mulher',
  iconType: 'component',
  iconComponent: SaudeDaMulherIcon,
  buscaAtiva: {
    // a: ({ cidadao, formatDate }) =>
    //   `Cidadão ${cidadao?.no_cidadao || '-'} nascido em ${
    //     cidadao?.dt_nascimento ? formatDate(cidadao.dt_nascimento) : '-'
    //   }.`,
    a: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para coletar, solicitar ou Avaliar o exame de rastreamento do câncer do colo do útero (em atraso).'
        : 'Coletar, solicitar ou Avaliar o exame de rastreamento do câncer do colo do útero (em atraso).',
    b: 'Encaminhar para a vacina HPV (em atraso).',
    c: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para realizar e registrar a consulta de saúde sexual e reprodutiva (em atraso).'
        : 'Realizar e registrar a consulta de saúde sexual e reprodutiva (em atraso).',
    d: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para solicitar ou avaliar o exame de rastreamento do câncer de mama (em atraso).'
        : 'Solicitar ou avaliar o exame de rastreamento do câncer de mama (em atraso).',
  },
}
